import { Component, Input, Output, TemplateRef, OnChanges, SimpleChanges, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-pharma-slider-filter',
  templateUrl: './pharma-slider-filter.component.html',
  styleUrls: ['./pharma-slider-filter.component.scss']
})
export class PharmaSliderFilterComponent implements OnChanges{
  @Input() label: string;
  @Input() showLabel: boolean;
  @Input() min: number;
  @Input() max: number;
  @Input() step: number;
  @Input() selectedMin: number;
  @Input() selectedMax: number;
  @Input() magnitude: string;
  @Input() currency: string;
  @Input() isDisabled = false;
  @Input() valueFormatter: TemplateRef<any>;
  @Output() onSelectionChange: EventEmitter<any> = new EventEmitter();
  @Output() onInstantMinMaxChange: EventEmitter<any> = new EventEmitter();

  ngOnChanges(changes: SimpleChanges) {
    // console.log("slider filter",changes);
  }

  onMinValueChange(valueObj) {
    // console.log("min value changed to :", valueObj);
    this.selectedMin = valueObj && valueObj.value;
    this.emitMinMaxValues();
  }

  onMaxValueChange(valueObj) {
    this.selectedMax = valueObj && valueObj.value;
    this.emitMinMaxValues();
  }

  emitMinMaxValues() {
    console.log("changed");
    this.onSelectionChange.emit({min: this.selectedMin, max: this.selectedMax});
  }

  onInstantMinChange(value) {
    // console.log(value)
    // console.log(another)
    this.selectedMin = value;
    this.onInstantMinMaxChange.emit({min: this.selectedMin, max: this.selectedMax})
  }

  onInstantMaxChange(value) {
    // console.log(value)
    // console.log(another)
    this.selectedMax = value;
    this.onInstantMinMaxChange.emit({min: this.selectedMin, max: this.selectedMax})
  }
}
